module.exports = __webpack_public_path__ + "img/2.fd1db7b5.png";